// recon-bank-finish-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcb.finish.assertFailed': 'Bankutskriften kan ikke avstemmes ennå.',
  'rcb.finish.archiveRejected': 'Arkiveringen ble avvist.',
  'rcb.finish.unhandledLines': 'Kan ikke arkivere ennå: {count} banklinje(r) er ikke ferdig håndtert{label}{status}.',
  'rcb.finish.balanceDeviation': 'Kan ikke arkivere ennå: saldoavviket er {deviation} kr.',
  'rcb.finish.failed': 'Kunne ikke avstemme bankutskriften.',
});
